export default __webpack_public_path__ + "static/ordre-05159f4ed4dd6a4328f6762967d27bf4.png";